import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        VRow,
        [
          _c(
            VCol,
            { attrs: { xl: "8", lg: "8", md: "12", sm: "12", xs: "12" } },
            [
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    {
                      attrs: { xl: "6", lg: "6", md: "12", sm: "12", xs: "12" },
                    },
                    [
                      _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("my_tasks.modals.organization")
                                    ) + ":"
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            [
                              _c(VSelect, {
                                attrs: {
                                  dense: "",
                                  outlined: "",
                                  disabled: _vm.readonly,
                                  items: _vm.organizations,
                                  rules: _vm.requiredFlag
                                    ? [
                                        function (v) {
                                          return (
                                            _vm.organizations.includes(v) ||
                                            _vm.$t("my_tasks.modals.required")
                                          )
                                        },
                                        function (v) {
                                          return (
                                            !!v ||
                                            _vm.$t("my_tasks.modals.required")
                                          )
                                        },
                                      ]
                                    : [],
                                },
                                model: {
                                  value: _vm.item.organization,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.item, "organization", $$v)
                                  },
                                  expression: "item.organization",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("my_tasks.modals.operator")) +
                                      ":"
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            [
                              _c(VTextField, {
                                attrs: {
                                  dense: "",
                                  outlined: "",
                                  disabled: _vm.readonly,
                                  rules: [
                                    function (v) {
                                      return (
                                        !!v ||
                                        _vm.$t("my_tasks.modals.required")
                                      )
                                    },
                                    function (v) {
                                      return (
                                        /[a-z0-9]+@[a-z]+.[a-z]{2,3}.[a-z]{2,3}/.test(
                                          v
                                        ) ||
                                        _vm.$t("my_tasks.modals.email_invalid")
                                      )
                                    },
                                  ],
                                },
                                model: {
                                  value: _vm.item.data_operator,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.item, "data_operator", $$v)
                                  },
                                  expression: "item.data_operator",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("my_tasks.modals.description")
                                    ) + ":"
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            [
                              _c(VTextarea, {
                                attrs: {
                                  dense: "",
                                  outlined: "",
                                  disabled: _vm.readonly,
                                  "no-resize": "",
                                  rows: "3",
                                  rules: _vm.requiredFlag
                                    ? [
                                        function (v) {
                                          return (
                                            !!v ||
                                            _vm.$t("my_tasks.modals.required")
                                          )
                                        },
                                      ]
                                    : [],
                                },
                                model: {
                                  value: _vm.item.object_description,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.item,
                                      "object_description",
                                      $$v
                                    )
                                  },
                                  expression: "item.object_description",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    {
                      attrs: { xl: "6", lg: "6", md: "12", sm: "12", xs: "12" },
                    },
                    [
                      _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("my_tasks.modals.domain")) +
                                      ":"
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            [
                              _c(VSelect, {
                                attrs: {
                                  dense: "",
                                  outlined: "",
                                  disabled: _vm.readonly,
                                  items: _vm.selectDomain,
                                  rules: _vm.requiredFlag
                                    ? [
                                        function (v) {
                                          return (
                                            !!v ||
                                            _vm.$t("my_tasks.modals.required")
                                          )
                                        },
                                      ]
                                    : [],
                                },
                                on: {
                                  change: function ($event) {
                                    _vm.item.ksubdomain = ""
                                  },
                                },
                                model: {
                                  value: _vm.item.kdomain,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.item, "kdomain", $$v)
                                  },
                                  expression: "item.kdomain",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("my_tasks.modals.subdomain")
                                    ) + ":"
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            [
                              _c(VSelect, {
                                attrs: {
                                  dense: "",
                                  outlined: "",
                                  disabled: _vm.readonly,
                                  items: _vm.filterSubDomain,
                                  rules: _vm.requiredFlag
                                    ? [
                                        function (v) {
                                          return (
                                            !!v ||
                                            _vm.$t("my_tasks.modals.required")
                                          )
                                        },
                                      ]
                                    : [],
                                },
                                model: {
                                  value: _vm.item.ksubdomain,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.item, "ksubdomain", $$v)
                                  },
                                  expression: "item.ksubdomain",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("my_tasks.modals.environment")
                                    ) + ":"
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            [
                              _c(VSelect, {
                                attrs: {
                                  dense: "",
                                  outlined: "",
                                  disabled: _vm.readonly,
                                  items:
                                    _vm.DEFAULT_TPL_FIELDS.ENVIRONMENT
                                      .enumValues,
                                },
                                model: {
                                  value: _vm.item.environment,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.item, "environment", $$v)
                                  },
                                  expression: "item.environment",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("my_tasks.modals.sensitive")
                                    ) + ":"
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "1" } },
                            [
                              _c(VCheckbox, {
                                attrs: { disabled: _vm.readonly },
                                model: {
                                  value: _vm.item.sensitive_data,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.item, "sensitive_data", $$v)
                                  },
                                  expression: "item.sensitive_data",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    { attrs: { lg: "6" } },
                    [
                      _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("my_tasks.tablas_tasks.dataset")
                                    ) + "s:"
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            [
                              _c(VDataTable, {
                                staticClass: "elevation-1 ma-1",
                                attrs: {
                                  "pagination-disabled": "",
                                  "hide-default-footer": "",
                                  dense: "",
                                  items: _vm.item.datasets,
                                  headers: [
                                    { value: "object_name", text: "Dataset" },
                                    {
                                      value: "datasources[0].datasourceType",
                                      text: "Datasource",
                                    },
                                  ],
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "item.object_name",
                                    fn: function (row) {
                                      return [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: "javascript:void(0)",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onShowDataset(
                                                  row.item
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(row.item.object_name))]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { staticClass: "form-row", attrs: { sm: "12", lg: "6" } },
                    [
                      _c(
                        VCol,
                        { attrs: { sm: "12", lg: "12" } },
                        [
                          _c(
                            VRow,
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "4" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("my_tasks.modals.app")) +
                                          ":"
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      disabled: true,
                                    },
                                    model: {
                                      value: _vm.item.app_name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.item, "app_name", $$v)
                                      },
                                      expression: "item.app_name",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { sm: "12", lg: "12" } },
                        [
                          _c(
                            VRow,
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "4" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("my_tasks.modals.workspace")
                                        ) + ":"
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                [
                                  _c(VTextField, {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover.right",
                                        modifiers: { hover: true, right: true },
                                      },
                                    ],
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      disabled: true,
                                      title: _vm.item.workspace_description,
                                    },
                                    model: {
                                      value: _vm.item.workspace_name,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.item,
                                          "workspace_name",
                                          $$v
                                        )
                                      },
                                      expression: "item.workspace_name",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VCol,
            { attrs: { xl: "4", lg: "4", md: "12", sm: "12", xs: "12" } },
            [
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    {
                      attrs: {
                        xl: "12",
                        lg: "12",
                        md: "12",
                        sm: "12",
                        xs: "12",
                      },
                    },
                    [
                      _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            {
                              staticClass: "mb-2",
                              staticStyle: { height: "130px" },
                              attrs: { md: "2" },
                            },
                            [
                              _c(
                                VBtn,
                                {
                                  attrs: {
                                    icon: "",
                                    outlined: "",
                                    color: "secondary",
                                    disabled: _vm.readonly,
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.$refs.imageInput.$el
                                        .querySelector("input[type=file]")
                                        .click()
                                    },
                                  },
                                },
                                [
                                  _c(VIcon, { attrs: { small: "" } }, [
                                    _vm._v("mdi-file-image"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            {
                              staticClass: "mb-2 text-right",
                              staticStyle: { height: "130px", padding: "0px" },
                              attrs: { md: "10" },
                            },
                            [
                              _c("b-form-file", {
                                ref: "imageInput",
                                staticStyle: { display: "none" },
                                attrs: {
                                  accept: _vm.METADATA_IMAGE_FORMAT.join(","),
                                  "v-if": _vm.cantUploadPreview(),
                                },
                                on: { change: _vm.onFileChangeImage },
                                model: {
                                  value: _vm.inputUploadImage,
                                  callback: function ($$v) {
                                    _vm.inputUploadImage = $$v
                                  },
                                  expression: "inputUploadImage",
                                },
                              }),
                              _vm.item.report_image
                                ? _c(VImg, {
                                    class: { ejemplo: _vm.isHovered },
                                    staticStyle: {
                                      padding: "0%",
                                      cursor: "zoom-in",
                                    },
                                    attrs: {
                                      src: _vm.item.report_image,
                                      alt: _vm.item.object_name,
                                      "max-height": "150",
                                      "max-width": "150",
                                      contain: "",
                                    },
                                    on: {
                                      mouseover: function ($event) {
                                        _vm.isHovered = true
                                      },
                                      mouseleave: function ($event) {
                                        _vm.isHovered = false
                                      },
                                      click: function ($event) {
                                        return _vm.$bvModal.show("imagemodal")
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _c(
                                "b-modal",
                                {
                                  attrs: {
                                    id: "imagemodal",
                                    "hide-footer": "",
                                  },
                                },
                                [
                                  _c("img", {
                                    staticClass: "imagepreview",
                                    staticStyle: { width: "100%" },
                                    attrs: { src: _vm.item.report_image },
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    {
                      attrs: {
                        xl: "12",
                        lg: "12",
                        md: "12",
                        sm: "12",
                        xs: "12",
                      },
                    },
                    [
                      _c(
                        VBtn,
                        {
                          attrs: {
                            icon: "",
                            outlined: "",
                            color: "secondary",
                            disabled: _vm.readonly,
                          },
                          on: {
                            click: function ($event) {
                              _vm.$refs.fileInput.$el
                                .querySelector("input[type=file]")
                                .click()
                            },
                          },
                        },
                        [_c(VIcon, [_vm._v("mdi-paperclip")])],
                        1
                      ),
                      _c("b-form-file", {
                        ref: "fileInput",
                        staticStyle: { display: "none" },
                        attrs: { accept: _vm.METADATA_FILE_FORMAT.join(",") },
                        on: { change: _vm.onFileChange },
                        model: {
                          value: _vm.inputUploadFile,
                          callback: function ($$v) {
                            _vm.inputUploadFile = $$v
                          },
                          expression: "inputUploadFile",
                        },
                      }),
                      _c(
                        VSimpleTable,
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.files.length,
                              expression: "files.length",
                            },
                          ],
                          attrs: {
                            small: true,
                            hover: true,
                            "sticky-header": "",
                          },
                        },
                        [
                          _c(
                            "tbody",
                            _vm._l(_vm.files, function (file, index) {
                              return _c("tr", { key: index }, [
                                _c(
                                  "td",
                                  {
                                    staticStyle: {
                                      "text-align": "left",
                                      "vertical-align": "middle",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        file.fileName.substring(
                                          file.fileName.length - 23,
                                          file.fileName.length
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "td",
                                  {
                                    staticStyle: {
                                      "text-align": "center",
                                      "vertical-align": "middle",
                                      padding: "0px",
                                    },
                                  },
                                  [
                                    _vm.METADATA_IMAGE_FORMAT.filter(function (
                                      format
                                    ) {
                                      return file.fileName
                                        .toLowerCase()
                                        .endsWith(format)
                                    }).length
                                      ? _c(
                                          VIcon,
                                          {
                                            attrs: {
                                              small: "",
                                              color: "primary",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onClickLink(file)
                                              },
                                            },
                                          },
                                          [_vm._v("mdi-file-image")]
                                        )
                                      : _c(
                                          VIcon,
                                          {
                                            attrs: {
                                              small: "",
                                              color: "#515154",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.openImage(
                                                  file.fileLink
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("icon-download")]
                                        ),
                                  ],
                                  1
                                ),
                                _c(
                                  "td",
                                  {
                                    staticStyle: {
                                      "text-align": "center",
                                      "vertical-align": "middle",
                                      padding: "0px",
                                    },
                                  },
                                  [
                                    !_vm.readonly
                                      ? _c(
                                          VIcon,
                                          {
                                            staticClass: "btn-icon-inca",
                                            staticStyle: { cursor: "pointer" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.deleteFile(file)
                                              },
                                            },
                                          },
                                          [_vm._v("icon-delete")]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ])
                            }),
                            0
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "preview-file",
          attrs: {
            id: "preview-file",
            "hide-footer": "",
            "no-close-on-backdrop": true,
            "no-close-on-esc": true,
          },
        },
        [
          _c(
            "b-col",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.currentFile.fileLink &&
                    _vm.METADATA_IMAGE_FORMAT.filter(function (file) {
                      return _vm.currentFile.fileName
                        .toLowerCase()
                        .endsWith(file)
                    }).length,
                  expression:
                    "currentFile.fileLink && METADATA_IMAGE_FORMAT.filter(file => currentFile.fileName.toLowerCase().endsWith(file)).length",
                },
              ],
            },
            [
              _c(
                "a",
                {
                  attrs: {
                    href: _vm.currentFile.fileLink,
                    download: _vm.currentFile.fileName,
                    target: "_blank",
                  },
                },
                [
                  _c("b-img", {
                    attrs: {
                      src: _vm.currentFile.fileLink,
                      fluid: "",
                      alt: _vm.currentFile.fileName,
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }